export function getLimitedDateRanges() {
    const minimumDate = new Date();
    minimumDate.setFullYear(2019, 0, 0);

    const maximumDate = new Date();
    maximumDate.setFullYear(maximumDate.getFullYear() + 1, 11, 31);

    return {
        minDate: minimumDate,
        maxDate: maximumDate,
    };
}
